import { render, staticRenderFns } from "./IconWordSpacing.vue?vue&type=template&id=28ac0fff&"
import script from "./IconWordSpacing.vue?vue&type=script&lang=ts&"
export * from "./IconWordSpacing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports